import React, { useEffect, useState, useRef } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../url';
import './Banners.css';
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper/core';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import logo from '../../images/4.png'; // 👈 importo el logo (igual que en Navbar)

SwiperCore.use([Navigation, Pagination, Autoplay]);

export default function Banners() {
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [mobileImages, setMobileImages] = useState([]);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const swiperRef = useRef(null);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        cargarBanners();
    }, []);

    useEffect(() => {
        if (swiperRef.current) {
            swiperRef.current?.update();
        }
    }, [images, mobileImages]);

    const cargarBanners = () => {
        fetch(`${baseURL}/bannersGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                const bannerImages = data.banner
                    .filter(banner => banner.financiacion !== 1 && banner.isMobile !== 1)
                    .map(banner => ({ src: banner.imagen, tipo: banner.tipo, texto: banner.texto }));

                setImages(bannerImages);

                const smallBannerImages = data.banner
                    .filter(banner => banner.financiacion !== 1 && banner.isMobile === 1)
                    .map(banner => ({ src: banner.imagen, tipo: banner.tipo, texto: banner.texto }));
                setMobileImages(smallBannerImages);

                setLoading(false);
            })
            .catch(error => {
                console.error('Error al cargar productos:', error)
            });
    };

    const handleVerCatalogo = () => {
        console.log('Navegando al catálogo...');
    };

    const activeImages = isMobile ? mobileImages : images;

    return (
        <div className='BannerContain'>
            {loading ? (
                <div className='loadingBanner'>
                    <div className='catalog-button-container'>
                        <div className='catalog-content'>
                            {/* 👇 Logo en vez de texto */}
                            <img
                                src={logo}
                                alt="Ruta 20 motos Logo"
                                className="catalog-logo"
                            />

                            {/*<p className='catalog-subtitle'>
                                "El auto que buscas, con la transparencia que mereces."
                            </p>*/}

                            {/*<button className='catalog-button' onClick={handleVerCatalogo}>
                                Explora nuestro catalogo
                            </button>*/}
                        </div>
                    </div>
                </div>

            ) : (
                <div className='banner-wrapper'>
                    {/* El logo superpuesto en el centro del carrusel se sacó a pedido:
                        tapaba las imágenes/videos de los banners reales. */}

                    {activeImages.length > 0 && (
                        // Con 0 slides Swiper rompe al calcular clases (updateSlidesClasses),
                        // así que sólo se inicializa cuando hay al menos un banner cargado.
                        <Swiper
                            effect={'coverflow'}
                            grabCursor={true}
                            loop={true}
                            slidesPerView={'auto'}
                            coverflowEffect={{ rotate: 0, stretch: 0, depth: 100, modifier: 2.5 }}
                            navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }}
                            autoplay={{ delay: 3000 }}
                            pagination={{ clickable: true }}
                            onSwiper={(swiper) => {
                                swiperRef.current = swiper;
                            }}
                            id='swiper_container'
                        >
                            {activeImages.map((image, index) => (
                                <SwiperSlide id='SwiperSlide-scroll' key={index}>
                                    {image.tipo === 'video' ? (
                                        <video
                                            src={image.src}
                                            autoPlay
                                            muted
                                            loop
                                            playsInline
                                        />
                                    ) : (
                                        <img src={image.src} alt={`imagen-${index}`} />
                                    )}
                                    {image.texto && (
                                        <div className='banner-texto-overlay'>
                                            <span>{image.texto}</span>
                                        </div>
                                    )}
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    )}
                </div>
            )}
        </div>
    );
}
